import React from 'react'
import PropTypes from 'prop-types'
const Carret = (props) => {

    return (
        <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0L9 9L18 0H0Z" fill={props.fill} fillOpacity="0.54"/>
        </svg>
    )
}
Carret.propTypes = {
    fill: PropTypes.string
}
export default Carret
